module.exports = __webpack_public_path__ + "static/img/3.d961b99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v15_new_features/3.png
// module id = NoYR
// module chunks = 0